import { useState } from 'react';

import { Input, InputChangeEventHandler } from '../../index';

export interface NumberRangeProps {
  label?: string;
  defaultMin?: number;
  defaultMax?: number;
  onChange: (min: number, max: number) => void;
}

export const NumberRange = (props: NumberRangeProps) => {
  const { label, defaultMin, defaultMax, onChange } = props;
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(0);

  const onMinChange: InputChangeEventHandler = (e) => {
    const newMin = Number(e.target.value);
    setMin(newMin);
    onChange(newMin, max);
  };

  const onMaxChange: InputChangeEventHandler = (e) => {
    const newMax = Number(e.target.value);
    setMax(newMax);
    onChange(min, newMax);
  };

  return (
    <div>
      {label && <label className="mb-1 inline-block">{label}</label>}
      <div className="flex flex-row">
        <div className="w-36">
          <label htmlFor="min" className="display-none" />
          <Input name="min" placeholder="Minimum" type="number" defaultValue={defaultMin} onChange={onMinChange} />
        </div>
        <span className="p-2">-</span>
        <div className="w-36">
          <label htmlFor="max" className="display-none" />
          <Input name="max" placeholder="Maximum" type="number" defaultValue={defaultMax} onChange={onMaxChange} />
        </div>
      </div>
    </div>
  );
};
export default NumberRange;
